import { RebateOverview } from "@/gql/graphql";

export const getActiveGoalId = (rebate: RebateOverview | undefined) =>
  getActiveGoal(rebate)?.id;

export const getExpectedGoal = (rebate: RebateOverview | undefined) =>
  rebate
    ? rebate.goals
        .filter((goal) => goal.targetValue <= goal.expectedVolume)
        .sort((a, b) => b.targetValue - a.targetValue)
        .at(0)
    : null;

export const getActiveGoal = (rebate: RebateOverview | undefined) => {
  if (!rebate) {
    return null;
  }
  const achievedGoal = getAchievedGoal(rebate);
  if (achievedGoal) {
    return achievedGoal;
  }

  return [...rebate.goals].sort((a, b) => a.targetValue - b.targetValue).at(0);
};
export const getAchievedGoal = (rebate: RebateOverview | undefined) => {
  if (!rebate) {
    return null;
  }
  const reachedGoal = rebate.goals
    .filter((goal) => goal.targetValue <= rebate.achieved)
    .sort((a, b) => b.targetValue - a.targetValue)
    .at(0);

  return reachedGoal;
};

export const getAuthorizedBy = (rebate: RebateOverview | undefined) =>
  getExpectedGoal(rebate)?.authorizedBy?.replace("LINE\\", "");

const joinDistinct = (values: Array<string | null | undefined>) =>
  [...new Set(values.filter((value): value is string => !!value))].join(", ");

export const getCriteriaNames = (rebate: RebateOverview | undefined) =>
  joinDistinct(rebate?.criterias.map((criteria) => criteria.name) ?? []);

export const getCriteriaDescriptions = (rebate: RebateOverview | undefined) =>
  joinDistinct(rebate?.criterias.map((criteria) => criteria.description) ?? []);

export const getRebateModelCode = (rebate: RebateOverview | undefined) =>
  rebate?.criterias.at(0)?.rebateModelCode;
